import { motion } from 'framer-motion';

const styles = {
  section: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #0a0a0a 0%, #141414 50%, #0a0a0a 100%)',
    padding: '60px 20px 40px',
    position: 'relative',
    overflow: 'hidden',
  },
  glow1: {
    position: 'absolute',
    width: '500px',
    height: '500px',
    borderRadius: '50%',
    filter: 'blur(140px)',
    opacity: 0.15,
    background: '#08F654',
    top: '-150px',
    right: '-100px',
  },
  glow2: {
    position: 'absolute',
    width: '400px',
    height: '400px',
    borderRadius: '50%',
    filter: 'blur(120px)',
    opacity: 0.08,
    background: '#08F654',
    bottom: '-100px',
    left: '-100px',
  },
  content: {
    maxWidth: '1100px',
    width: '100%',
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  topSection: {
    textAlign: 'center',
    marginBottom: '48px',
  },
  badge: {
    display: 'inline-block',
    padding: '8px 20px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: 700,
    color: '#08F654',
    background: 'rgba(8,246,84,0.08)',
    border: '1px solid rgba(8,246,84,0.2)',
    marginBottom: '24px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  title: {
    fontSize: 'clamp(2.2rem, 5.5vw, 3.5rem)',
    fontWeight: 900,
    color: '#ffffff',
    lineHeight: 1.1,
    marginBottom: '12px',
  },
  highlight: {
    color: '#08F654',
  },
  subtitle: {
    fontSize: 'clamp(1rem, 2vw, 1.2rem)',
    color: '#a1a1aa',
    lineHeight: 1.6,
    marginBottom: '32px',
    maxWidth: '600px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  buttonRow: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginBottom: '12px',
  },
  button: {
    padding: '16px 48px',
    fontSize: '18px',
    fontWeight: 800,
    color: '#000000',
    background: '#08F654',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    boxShadow: '0 4px 24px rgba(8,246,84,0.3)',
    fontFamily: 'inherit',
  },
  priceTag: {
    fontSize: '0.95rem',
    color: '#71717a',
    marginTop: '8px',
  },
  priceAmount: {
    color: '#08F654',
    fontWeight: 700,
  },
  currencyNote: {
    fontSize: '1rem',
    fontWeight: 600,
    color: '#08F654',
    marginTop: '4px',
    letterSpacing: '0.5px',
  },
  imageGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '16px',
    width: '100%',
    maxWidth: '900px',
  },
  imageCard: {
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid rgba(255,255,255,0.08)',
    aspectRatio: '1',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  imageLabel: {
    textAlign: 'center',
    padding: '10px 0 0',
    fontSize: '0.8rem',
    fontWeight: 600,
    color: '#a1a1aa',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
};

function Hero({ onGetCourse }) {
  return (
    <section style={styles.section}>
      <div style={styles.glow1} />
      <div style={styles.glow2} />
      <div style={styles.content}>
        <motion.div
          style={styles.topSection}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span style={styles.badge}>250 Templates Inside</span>
          <h1 style={styles.title}>
            Stop Begging for Designs.<br />
            <span style={styles.highlight}>Make Your Own.</span>
          </h1>
          <p style={styles.subtitle}>
            250 editable PSD templates — flyers, mockups & text effects.
            Just open in Photoshop, tweak, and post. No design skills needed.
          </p>
          <div style={styles.buttonRow}>
            <motion.button
              style={styles.button}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              onClick={onGetCourse}
            >
              Download Now
            </motion.button>
          </div>
          <p style={styles.priceTag}>
            Just <span style={styles.priceAmount}>$2.99</span>
          </p>
          <p style={styles.currencyNote}>
            Pay in your local currency
          </p>
        </motion.div>

        <motion.div
          style={styles.imageGrid}
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <div>
            <div style={styles.imageCard}>
              <img src="/images/flyers.jpg" alt="Flyer templates" style={styles.image} />
            </div>
            <p style={styles.imageLabel}>Flyers & Posters</p>
          </div>
          <div>
            <div style={styles.imageCard}>
              <img src="/images/mockups.jpg" alt="Mockup templates" style={styles.image} />
            </div>
            <p style={styles.imageLabel}>Editable Mockups</p>
          </div>
          <div>
            <div style={styles.imageCard}>
              <img src="/images/texteffects.jpg" alt="Text effect templates" style={styles.image} />
            </div>
            <p style={styles.imageLabel}>PSD Text Effects</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default Hero;
